import { useNavigate } from "react-router-dom";
import { useApi } from "@/hooks/useApi";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, DataTable, StatusBadge, ErrorBox, Section } from "@/components/common/ui-bits";
import { DocumentsBox } from "@/components/common/DocumentsBox";
import { Progress } from "@/components/ui/progress";
import { fmtDate, money } from "@/lib/format";

export function PortalProposals() {
  const { data, loading, error } = useApi("/proposals");
  const navigate = useNavigate();
  return (
    <div>
      <PageHeader title="Mis propuestas" subtitle="Revise, seleccione una opción y acepte o solicite cambios." />
      <ErrorBox text={error} />
      <DataTable testid="portal-proposals-table" loading={loading} rows={data} onRowClick={(r) => navigate(`/portal/propuestas/${r.id}`)} empty="No tiene propuestas."
        columns={[
          { key: "title", label: "Propuesta", render: (r) => <span className="font-medium text-slate-900">{r.title}<span className="block text-xs text-slate-500">{r.number} · v{r.current_version}</span></span> },
          { key: "options", label: "Opciones", render: (r) => <span className="text-xs">{r.options.map((o) => `${o.name}: ${money(o.total)}`).join(" · ")}</span> },
          { key: "valid_until", label: "Vigente hasta", render: (r) => fmtDate(r.valid_until) },
          { key: "status", label: "Estado", render: (r) => <StatusBadge status={r.status} /> },
        ]} />
    </div>
  );
}

export function PortalProjects() {
  const { data, loading, error } = useApi("/projects");
  const navigate = useNavigate();
  return (
    <div>
      <PageHeader title="Mis proyectos" />
      <ErrorBox text={error} />
      <DataTable testid="portal-projects-table" loading={loading} rows={data} onRowClick={(r) => navigate(`/portal/proyectos/${r.id}`)} empty="No tiene proyectos."
        columns={[
          { key: "name", label: "Proyecto", render: (r) => <span className="font-medium text-slate-900">{r.name}</span> },
          { key: "type", label: "Tipo" },
          { key: "progress", label: "Avance", render: (r) => <div className="flex w-32 items-center gap-2"><Progress value={r.progress || 0} className="h-2" /><span className="num text-xs">{r.progress || 0}%</span></div> },
          { key: "estimated_delivery", label: "Entrega estimada", render: (r) => fmtDate(r.estimated_delivery) },
          { key: "status", label: "Estado", render: (r) => <StatusBadge status={r.status} /> },
        ]} />
    </div>
  );
}

export function PortalTaxes() {
  const { data, loading, error } = useApi("/tax-cases");
  const navigate = useNavigate();
  return (
    <div>
      <PageHeader title="Mis casos de taxes" subtitle="Estado de sus casos y documentos pendientes." />
      <ErrorBox text={error} />
      <DataTable testid="portal-tax-table" loading={loading} rows={data} onRowClick={(r) => navigate(`/portal/taxes/${r.id}`)} empty="No tiene casos fiscales."
        columns={[
          { key: "title", label: "Caso", render: (r) => <span className="font-medium text-slate-900">{r.title}<span className="block text-xs text-slate-500">{r.number}</span></span> },
          { key: "docs", label: "Documentos pendientes", render: (r) => (r.documents || []).filter((d) => d.status === "Pendiente").length },
          { key: "status", label: "Estado", render: (r) => <StatusBadge status={r.status} /> },
        ]} />
    </div>
  );
}

export function PortalDocuments() {
  const { user } = useAuth();
  return (
    <div>
      <PageHeader title="Documentos" subtitle="Suba documentos de forma segura. Solo usted y nuestro equipo pueden verlos." />
      <Section><DocumentsBox clientId={user.client_id} testid="portal-documents" /></Section>
    </div>
  );
}
